import { SAVE_MENU_AUTH_DATA, RESET_MENU_AUTH_DATA } from "./action";

const initState = {
  menuAuthInfo: null,
};

export const menuAuthReducer = (state = initState, action) => {
  switch (action.type) {
    case SAVE_MENU_AUTH_DATA:
      return {
        ...state,
        menuAuthInfo: action.payload,
      };
    case RESET_MENU_AUTH_DATA:
      return initState;
    default:
      return state;
  }
};
